import axios from '../index'

export default {
    getInfoPersona (params) {
        return axios.get('/api/v1/personas/info' , {
            params
        })
    },
    getDataGeneralPersona (params) {
        return axios.get('/api/v1/personas/reporte', {
            params
        })
    },
    getPagosPersona (params) {
        return axios.get('/api/v1/personas/pagos', {
            params
        })
    },
    getCargosPersona (params) {
        return axios.get( "/api/v1/personas/cargos", {
            params
        })
    },
    getFactura(image, params) {
        return axios.get('' + image, {
            responseType: 'blob',
            params: params,
        })
    },
    getFacturaTemp(personaId, id , uuid, params) {
        return axios.get('/api/cfdis/' + uuid + '/pdf', {
            responseType: 'blob',
            params: params,
        })
    },
    downloadXML(personaId, id , uuid, params){
        return axios.get('/estado-de-cuenta/facturacion/'+ personaId + '/persona/' + id + '/movimiento/xml/tipo/factura/' + uuid, {
            responseType: 'blob',
            params: params,
        })
    },
    postFactura (payload) {
        return axios.post('/asignar-bloques/store', payload)
    },
    getInfoAccion(personaId, id , params) {
        return axios.get('/estado-de-cuenta/facturacion/'+ personaId +'/persona/'+ id + '/movimiento/factura', {
            responseType: 'blob',
            params: params,
        })
    },
    getGenerarCargos (formData) {
        return axios.post('/api/v1/cobranza/acciones/generar-cargos', formData)
    },
    getRestablecerCargos(formData) {
        return axios.post('/api/v1/cobranza/acciones/borrar-cargos', formData)
    },
    postAplicarBecas(formData) {
        return axios.post('/api/v1/cobranza/acciones/generar-becas', formData)
    },
    postDesaplicarBecas(formData) {
        return axios.post('/api/v1/cobranza/acciones/desaplicar-becas', formData)
    },
    postAplicarPagos(formData) {
        return axios.post('/api/v1/cobranza/acciones/aplicar-pagos', formData)
    },
    postReestablecerSaldos(formData) {
        return axios.post('/api/v1/cobranza/acciones/restablecer-saldos', formData)
    },
    getInfoAccionButton (formData) {
        return axios.post('/api/v1/cobranza/acciones/aplicar', formData)
    },

    getInfoEstadisticasCargo (params) {
        return axios.get('/api/', {
            params
        })
    },
    getInfoEstadisticasPago (params) {
        return axios.get('/api/v1/personas/reportes/pagos', {params})
    },
    getInfoEstadisticasCargo (params) {
        return axios.get('/api/v1/personas/reportes/cargos', {params})
    },
    getPrograma(params) {
        return axios.get('/api/v1/programas/directiva', {
            params
        })
    },
    getNivel(params) {
        return axios.get('/api/v1/niveles-academicos/directiva', {
            params
        })
    },
    postFacturar (params) {
        return axios.post('/api/v1/cobranza/facturacion/facturar', 
           params
        )
    },
    postParcializar (params) {
        return axios.post('/api/v1/cobranza/parcializacion-libre', 
           params
        )
    },
    getConceptos(params) {
        return axios.get('/api/v1/cobranza/listado/conceptos', {
            params
         })
    },
    registrarPago (params) {
        return axios.post('/api/v1/personas/registrar-pago',
         params
        )
    },
    getCancelFactura(uuid, idInstituto) {
        return axios.post('/api/v1/cobranza/facturacion/' + uuid + '/cfdi/' + idInstituto + '/institucion/cancelar-factura')
    },
    getCargosNoObligatorios (params) {
        return axios.get( '/api/v1/personas/servicios', {params})
    },
    postPagar (params) {
        return axios.post('/api/v1/cobranza/intencion-de-pagos/general/generar', 
           params
        )
    },
    vistaIntencion (params) {
        try {
            let windowName = 'w_' + Date.now() + Math.floor(Math.random() * 100000).toString();
            const crfToken = document.querySelector('meta[name="csrf-token"]').content
            var form = document.createElement("form");
            form.setAttribute("method", "post");
            form.setAttribute("action", "/api/v1/cobranza/intencion-de-pagos/general/modal");
            form.setAttribute("target", windowName);
            let datos = document.createElement("input"); 
            let cadena_json = document.createElement("input")
            let persona = document.createElement("input")
            let token = document.createElement("input")
            
            datos.setAttribute("type", "hidden");
            datos.setAttribute("name", "datos");
            datos.setAttribute("value", JSON.stringify(params.datos));
    
            cadena_json.setAttribute("type", "hidden");
            cadena_json.setAttribute("name", "cadena_json");
            cadena_json.setAttribute("value", params.cadena_json);
    
            persona.setAttribute("type", "hidden");
            persona.setAttribute("name", "persona_id");
            persona.setAttribute("value", params.persona_id);
    
            token.setAttribute("type", "hidden");
            token.setAttribute("name", "_token");
            token.setAttribute("value", crfToken);
    
            form.appendChild(cadena_json);
            form.appendChild(datos);
            form.appendChild(persona);
            form.appendChild(token);
    
            document.body.appendChild(form);
            window.open('', windowName);
            form.submit();
        } catch (error) {
            throw error
        }
        // return axios.get('/api/v1/cobranza/vista-intencion', {
        //    params
        // })
    },
    postPagarSantander (params) {
        return axios.post('/api/v1/cobranza/intencion-de-pagos/santander/generar', 
           params
        )
    },
    vistaIntencionSantander (params) {
        try {
            let windowName = 'w_' + Date.now() + Math.floor(Math.random() * 100000).toString();
            const crfToken = document.querySelector('meta[name="csrf-token"]').content
            var form = document.createElement("form");
            form.setAttribute("method", "post");
            form.setAttribute("action", "/api/v1/cobranza/intencion-de-pagos/santander/modal");
            form.setAttribute("target", windowName);
            let datos = document.createElement("input"); 
            let cadena_json = document.createElement("input")
            let persona = document.createElement("input")
            let token = document.createElement("input")
            
            datos.setAttribute("type", "hidden");
            datos.setAttribute("name", "datos");
            datos.setAttribute("value", JSON.stringify(params.datos));
    
            cadena_json.setAttribute("type", "hidden");
            cadena_json.setAttribute("name", "cadena_json");
            cadena_json.setAttribute("value", params.cadena_json);
    
            persona.setAttribute("type", "hidden");
            persona.setAttribute("name", "persona_id");
            persona.setAttribute("value", params.persona_id);
    
            token.setAttribute("type", "hidden");
            token.setAttribute("name", "_token");
            token.setAttribute("value", crfToken);
    
            form.appendChild(cadena_json);
            form.appendChild(datos);
            form.appendChild(persona);
            form.appendChild(token);
    
            document.body.appendChild(form);
            window.open('', windowName);
            form.submit();
        } catch (error) {
            throw error
        }
    },
    getSelectCargos (formData) {
        return axios.post('/api/v1/cobranza/cancelaciones/cargo', formData)
    },
    getSelectPagos (typeCategory, formData) {
        return axios.post('/api/v1/cobranza/cancelaciones/pago', formData)
    },
    getGetDescuento (params) {
        return axios.post( '/api/v1/personas/registrar-descuento', params)
    },
    getGetDescuentoConceptos (params) {
        return axios.get( '/api/v1/personas/registrar-descuento', {params})
    },
    getReferencia(params){
        return axios.post('/api/v1/cobranza/intencion-de-pagos/santander', params)
    },
    getReferenciaPayPal(params){
        return axios.post('/api/v1/cobranza/intencion-de-pagos/paypal', params)
    },
    getPaypalClient(institucion){
        return axios.get(`/api/v2/paypal/getClient/${institucion}`)
    },
    postWire4Checkout(params) {
        try {
          let windowName = 'w_' + Date.now() + Math.floor(Math.random() * 100000).toString();
          const crfToken = document.querySelector('meta[name="csrf-token"]').content
          var form = document.createElement("form");
          form.setAttribute("method", "post");
          form.setAttribute("action", "/v2/wire4/checkout");
          form.setAttribute("target", windowName);
      
          let data = document.createElement("input");
          data.setAttribute("type", "hidden");
          data.setAttribute("name", "data");
          data.setAttribute("value", JSON.stringify(params));
          form.appendChild(data);

          let token = document.createElement("input")
          token.setAttribute("type", "hidden");
          token.setAttribute("name", "_token");
          token.setAttribute("value", crfToken);
          form.appendChild(token);

          document.body.appendChild(form);
          window.open('', windowName);
          form.submit();
        } catch (error) {
          throw error
        }
    },
    getWire4Reference(params){
        return axios.post('/api/v1/cobranza/intencion-de-pagos/wire4', params)
    },
    getWire4Enabled(institucion){
        return axios.get(`/v2/wire4/enabled/${institucion}`)
    },
    getWire4CLABE(personaId, institucion){
        return axios.get(`/v2/wire4/clabe/${personaId}/${institucion}`)
    },
    getSantander(params) {
        return axios.get('/webpay/get-url', {params})
    },
    getRespuestaSigem(formData){
        return axios.post('/webpay/getStatusReferenciaWebpay', formData)
    },
    getDevolucion(formData){
        return axios.post('/api/v1/cobranza/devoluciones/pago', formData)
    },
    postDesaplicarParcialidad(formData){
        return axios.post('/api/v1/cobranza/acciones/revertir-parcialidades', formData)
    },
    getDatosContacto(institucion){
        return axios.get('/instituciones/datosContacto/' + institucion)
    },
    // HISTORIAL 
    getHistorial(params){
        return axios.get('/api/v1/cobranza/registro-de-actividad', {params})
    },

    postCancelar4(params){
        return axios.post('/api/facturacion/cancelar',params)
    }
}
